import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
// import { FormattedMessage, useIntl } from "gatsby-plugin-intl"
import { IntlContextConsumer, useIntl, changeLocale } from "gatsby-plugin-intl"
import Language from "./language"

import siteLogo from "../images/logo.png"

// const changeTheLocale = (localeStr) => {
//   const intl = useIntl()

//   intl.changeTheLocale("fr");

// }

const languageName = {
  en: "English",
  ko: "한국어",
  de: "Deutsch",
}

const Header = ({ siteTitle }) => {
  const intl = useIntl()

  return (
    <header
      style={{
        background: `rebeccapurple`,
        marginBottom: `1.45rem`,
      }}
    >
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `1.45rem 1.0875rem`,
        }}
      >

        <div>

          <div className="header clearfix">
            <img src={siteLogo} alt="Logo" />
            <h1 style={{ margin: 0 }}>
              <Link
                to="/"
                style={{
                  color: `white`,
                  textDecoration: `none`,
                }}
              >
                {siteTitle}
              </Link>
            </h1>
          </div>
        </div>

      </div>
    </header>

  )
}


Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
